import { PaymentFrequency } from '../../models/config/payment-frequency.enum';
import { RegisteredItemProductDetails } from '../../models/registered-item/registered-item-product-details.interface';
import { mockRegisteredItemProductPaymentMethod } from './registered-item-product-payment-method.mock';

export const mockRegisteredItemProductDetailsAnnual: RegisteredItemProductDetails =
  {
    discountedPrice: 55.77,
    paymentFrequency: PaymentFrequency.Prepay,
    paymentMethod: [mockRegisteredItemProductPaymentMethod],
    prepayMonths: 12,
    price: 63.72,
    warrantyProductName: 'Appliance Care Prepay IW/OOW',
    discountDetails: {
      discountedPrice: 55.77,
      discountAchCode: 'D50P3M',
      discountCcCode: 'D50P3M',
      discountedMonthsCount: 3,
      discountedMonthPercentage: 50,
    },
  };
